/* eslint-disable class-methods-use-this */
const $ = jQuery.noConflict();

class Quiz {
	constructor() {
		this.answerTrigger = $('.js-answer-trigger');
		this.heroStartButton = $('.page-template-tpl-quiz .btn');
		this.resultSection = $('.result');

		this.AnswerHandler = this.AnswerHandler.bind(this);
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.heroStartButton.on('click', this.scrollToNextSection);
		this.answerTrigger.on('click', this.AnswerHandler);
	}
	AnswerHandler(event) {
		event.preventDefault();
		const currentTarget = $(event.target);
		const currentSection = currentTarget.closest('section');
		currentSection.find(this.answerTrigger).removeClass('active');
		currentTarget.addClass('active');
		this.scrollToNextSection(event);
		this.updateCount();
	}
	scrollToNextSection(event) {
		event.preventDefault();
		const currentTarget = $(event.target);
		const nextSection = currentTarget.closest('section').next('section');
		nextSection.fadeIn(500);
		$('html, body').animate({
			scrollTop: nextSection.offset().top,
		}, 500);
	}
	updateCount() {
		const resultSections = Array.prototype.slice.call(this.resultSection);
		let result = -1;
		resultSections.forEach((element) => {
			const resCount = +$(`[data-result=${$(element).data('resultid')}].active`).length;
			if (resCount > result) {
				result = resCount;
			}
			$(element).attr('data-resultCount', resCount);
		});
		resultSections.forEach((element) => {
			if (result === +$(element).attr('data-resultCount')) {
				this.resultSection.removeClass('active');
				$(element).addClass('active');
			} else {
				$(element).removeClass('active');
			}
		});
	}
}

export default new Quiz();
